import './css/index.scss';

import 'regenerator-runtime/runtime';

import * as core from './core';
import * as forms from './forms';
import * as signatures from './signatures';
import * as snackbar from './snackbar';
import * as menu from './menu';
import * as location from './location';
import * as share from './share';
import * as utils from './utils';
import * as buttons from './buttons';
import * as copyright from './copyright';

const ec = {
  core,
  forms,
  signatures,
  snackbar,
  menu,
  location,
  share,
  utils,
  buttons,
  copyright
};

window.ec = ec;

export default ec;
